module.exports = __webpack_public_path__ + "static/img/8340.e30fa49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/8340.png
// module id = lzd8
// module chunks = 1